<template>
    <div :class="inputClass">
        <label
            v-if="label"
            :for="`${_uid}-input`"
            class="input__label"
            :class="{ 'required-input': mandatory }"
            v-text="label"/>
        <input
            :id="`${_uid}-input`"
            name="name"
            :placeholder="placeholder"
            v-model="val"
            :autocomplete="autocomplete"
            type="text"
            class="input__field"/>
        <p class="input__message"
           v-if="message"
           v-text="message"/>
    </div>
</template>

<script>
export default {
    name: 'InputField',
    data: () => {
        return {
            val: null,
        };
    },
    props: {
        autocomplete: {
            required: false,
            default: null,
        },
        value: {
            required: true,
        },
        label: {
            default: null,
            type: String,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        placeholder: {
            required: false,
            type: String,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        noPadding: {
            default: false,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        inputClass() {
            let noPadding = this.noPadding ? 'noPadding' : '';
            if (this.isValid !== false && this.value === null) {
                return `input ${noPadding}`;
            }
            if (!this.mandatory) {
                return this.val?.length ? `input input--success ${noPadding}` : `input ${noPadding}`;
            }

            return this.isValid && this.val ? `input input--success ${noPadding}` : `input input--invalid ${noPadding}`;
        },
    },
    watch: {
        val(value) {
            this.$emit('input', value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.val = value;
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.noPadding {
    padding: 0;
}
</style>
